// extracted by mini-css-extract-plugin
export default {"cls1":"FundingAccountsView-TitleSkeleton_cls1__2hqCs","cls2":"FundingAccountsView-TitleSkeleton_cls2__rYvxK FundingAccountsView-TitleSkeleton_cls1__2hqCs"};